var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 16.875V15H22.5V24.375H24.375V20.625H27.1875V18.75H24.375V16.875H28.125Z",
    fill: "#A7F234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 24.375H14.0625V15H17.8125C18.5582 15.0008 19.2731 15.2974 19.8003 15.8247C20.3276 16.3519 20.6242 17.0668 20.625 17.8125V21.5625C20.6242 22.3082 20.3276 23.0231 19.8003 23.5503C19.2731 24.0776 18.5582 24.3742 17.8125 24.375ZM15.9375 22.5H17.8125C18.0611 22.4997 18.2994 22.4009 18.4751 22.2251C18.6509 22.0494 18.7497 21.8111 18.75 21.5625V17.8125C18.7497 17.5639 18.6509 17.3256 18.4751 17.1499C18.2994 16.9741 18.0611 16.8753 17.8125 16.875H15.9375V22.5Z",
    fill: "#A7F234"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 15H5.625V24.375H7.5V21.5625H10.3125C10.8096 21.5618 11.2861 21.3641 11.6376 21.0126C11.9891 20.6611 12.1868 20.1846 12.1875 19.6875V16.875C12.1869 16.3779 11.9892 15.9013 11.6377 15.5498C11.2862 15.1983 10.8096 15.0006 10.3125 15ZM7.5 19.6875V16.875H10.3125L10.3134 19.6875H7.5Z",
    fill: "#A7F234"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 13.1253V9.37532C20.6284 9.2521 20.605 9.12963 20.5564 9.01633C20.5078 8.90303 20.4353 8.80162 20.3438 8.71907L13.7812 2.15657C13.6987 2.06501 13.5973 1.99244 13.484 1.94388C13.3707 1.89532 13.2482 1.87193 13.125 1.87532H3.75C3.25317 1.87678 2.7771 2.07479 2.42579 2.42611C2.07447 2.77742 1.87646 3.25349 1.875 3.75032V26.2503C1.875 26.7476 2.07254 27.2245 2.42417 27.5761C2.77581 27.9278 3.25272 28.1253 3.75 28.1253H18.75V26.2503H3.75V3.75032H11.25V9.37532C11.2515 9.87215 11.4495 10.3482 11.8008 10.6995C12.1521 11.0508 12.6282 11.2489 13.125 11.2503H18.75V13.1253H20.625ZM13.125 9.37532V4.12532L18.375 9.37532H13.125Z",
    fill: "#A7F234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.8767577a1798f94eaceb0a8f70303093.svg";
export { ForwardRef as ReactComponent };